export default __webpack_public_path__ + "static/clip-girl-study-1-12a0f9c92c5431128ce58b16501686fa.png";